var render = function render() {
  var _vm$objetoSelected;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descrição",
      "label-for": "descricao"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "maxLength": "100"
    },
    model: {
      value: _vm.form.descricao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "descricao", $$v);
      },
      expression: "form.descricao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "data_manutencao",
      "label-for": "data_manutencao",
      "label": "Data Manutenção"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "state": _vm.validateState('data_manutencao'),
      "locale": "pt-br",
      "date-format-options": {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      }
    },
    model: {
      value: _vm.form.data_manutencao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_manutencao", $$v);
      },
      expression: "form.data_manutencao"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "nome"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarCliente",
    attrs: {
      "state": _vm.validateState('cliente'),
      "entity-label": "cliente",
      "min-create-length": 3,
      "creating": _vm.criandoCliente,
      "value": _vm.form.cliente,
      "options": _vm.clientes,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setCliente,
      "create": _vm.criarClienteInline,
      "search": _vm.onSearchCliente
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.nome))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("CPF: " + _vm._s(_vm.formatCpfCnpj(option.cnpj_cpf)))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do cliente ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Técnico",
      "label-for": "tecnico"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarTecnico",
    class: {
      hasErrors: _vm.tecnicoError,
      inputFilled: _vm.tecnicoFilled
    },
    attrs: {
      "state": _vm.validateState('tecnico'),
      "entity-label": "técnico",
      "min-create-length": 3,
      "creating": _vm.criandoTecnico,
      "value": _vm.form.tecnico,
      "options": _vm.tecnicos,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setTecnico,
      "create": _vm.criarTecnicoInline,
      "open": _vm.onSearchTecnico,
      "search": _vm.onSearchTecnico
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.nome) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do tecnico ")])], 2)], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "10"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Objeto",
      "label-for": "objeto"
    }
  }, [_c('CadastroRapidoSelect', {
    ref: "buscarObjeto",
    attrs: {
      "label": "descricao",
      "entity-label": "objeto",
      "min-create-length": 3,
      "creating": _vm.criandoObjeto,
      "value": _vm.form.objeto,
      "options": _vm.objetos,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.setObjeto,
      "create": _vm.criarObjetoInline,
      "open": _vm.onSearchObjetos,
      "search": _vm.onSearchObjetos
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }])
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do objeto ")])], 2)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "confirmObjectModal",
      "centered": "",
      "title": "Vários Objetos para um mesmo cliente"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          on: {
            "click": function click() {
              cancel();
              _vm.openModal = false;
            }
          }
        }, [_vm._v(" Cancelar ")]), _c('b-button', {
          ref: "confirmObject",
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": _vm.confirmObject
          }
        }, [_vm._v(" Confirmar ")])];
      }
    }])
  }, [_c('b-row', [_c('b-col', [_c('p', [_vm._v(" Este cliente possui vários objetos cadastrados. Por favor, selecione o objeto desejado abaixo. ")])])], 1), _c('b-row', [_c('b-col', [_c('b-form-group', [_c('VueSelect', {
    ref: "buscarObjeto",
    attrs: {
      "filterable": false,
      "searchable": false,
      "options": _vm.objetosFetched,
      "clearSearchOnSelect": true
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(" " + _vm._s(option.descricao) + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.objetoSelected,
      callback: function callback($$v) {
        _vm.objetoSelected = $$v;
      },
      expression: "objetoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o nome do objeto ")])], 2)], 1)], 1)], 1), ((_vm$objetoSelected = _vm.objetoSelected) === null || _vm$objetoSelected === void 0 || (_vm$objetoSelected = _vm$objetoSelected.identificadores) === null || _vm$objetoSelected === void 0 ? void 0 : _vm$objetoSelected.length) > 0 ? _c('b-row', _vm._l(_vm.ordenarIdentificadores(_vm.objetoSelected.identificadores), function (identificador) {
    return _c('b-col', {
      key: identificador.id_identificador,
      attrs: {
        "sm": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": identificador.descricao,
        "label-for": identificador.descricao
      }
    }, [_c('b-form-input', {
      attrs: {
        "value": identificador.value,
        "disabled": ""
      }
    })], 1)], 1);
  }), 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };